import { render } from "./InstallPage.vue?vue&type=template&id=848c50f4&scoped=true"
import script from "./InstallPage.vue?vue&type=script&lang=js"
export * from "./InstallPage.vue?vue&type=script&lang=js"

import "./InstallPage.vue?vue&type=style&index=0&id=848c50f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848c50f4"]])

export default __exports__